export type Purchase = {
  name: string
  city: string
  state: string
  /** Minutos desde la compra (dato real del pedido). */
  minutesAgo: number
}

/**
 * Notificaciones de compra: SOLO con pedidos reales (ImpulTienda → ventas).
 * Producto nuevo: la lista queda vacía y el componente no muestra nada.
 */
export const recentPurchases: Purchase[] = []
